import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, Star } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-20 px-4 overflow-hidden" data-id="element-130">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#d4a843]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-131" />

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mt-[-35px] mb-[-35px]" data-id="element-133">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#112240] border border-[#d4a843]/30 text-[#d4a843] font-semibold text-sm mb-8" data-id="element-134">
            📚 BIBLIOTECAS DIGITALES™
          </div>

          <h1 className="md:text-6xl lg:text-7xl font-bold text-white mb-6 tracking-tight text-[24px]" data-id="element-135">
            Todo lo que necesitás para conseguir entrevistas en Argentina.
          </h1>

          <p className="md:text-5xl font-extrabold text-[#d4a843] mb-8 drop-shadow-lg text-[20px]" data-id="element-136">
            Listo. Desde hoy.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-137">
          <img src="https://cdn.magicpatterns.com/uploads/xm3Q8R8ZZbbes7cQaWbZW7/mockup_1.1_png.png" alt="MegaPack Empleo Mockup" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)] mt-[-20px] mb-[-20px]" data-id="element-138" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-139">
          {/* CTA */}
          <button onClick={scrollToPricing} className="group relative inline-flex items-center justify-center px-8 py-5 text-lg md:text-xl font-bold text-[#0a1628] bg-gradient-to-r from-[#d4a843] to-[#fcebb6] rounded-full overflow-hidden transition-all hover:scale-105 hover:shadow-[0_0_30px_rgba(212,168,67,0.4)] w-full md:w-auto max-w-md mb-10 pl-[36px] pr-[36px]" data-id="element-140">
            <span className="relative z-10 flex items-center gap-2 text-[24px]" data-id="element-141">
              → QUIERO MI MEGAPACK AHORA
            </span>
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-142" />
          </button>

          <p className="md:text-xl text-slate-300 mb-4 max-w-3xl mx-auto font-medium text-[16px]" data-id="element-143">
            El sistema N°1 de búsqueda laboral — CV + Estrategia + Negociación —
            Todo resuelto
          </p>

          <p className="md:text-lg text-slate-400 mb-12 text-[12px]" data-id="element-144">
            Sin buscar. Sin improvisar. Sin perder fines de semana.
          </p>

          {/* Badges */}
          <div className="flex flex-wrap gap-3 mb-10 items-end justify-center" data-id="element-145">
            {['📄 100% PDF', '⚡ Acceso en 5 min', '🇦🇷 Mercado argentino', '📚 6 Tomos + 6 Bonos'].map((badge, i) => <span key={i} className="px-4 py-2 rounded-full bg-[#112240] border border-slate-700 text-sm font-medium text-slate-200" data-id="element-146">
                {badge}
              </span>)}
          </div>

          {/* Trust Line */}
          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 mt-6 text-sm text-slate-400" data-id="element-147">
            <span className="flex items-center gap-1" data-id="element-148">
              <ShieldCheck className="w-4 h-4 text-[#d4a843]" data-id="element-149" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1" data-id="element-150">
              <Lock className="w-4 h-4 text-[#d4a843]" data-id="element-151" /> Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-152">
              <CreditCard className="w-4 h-4 text-[#d4a843]" data-id="element-153" /> Mercado Pago
            </span>
          </div>

          {/* Stats Row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mt-16 max-w-4xl mx-auto w-full border-t border-slate-800 pt-10" data-id="element-154">
            {[{
            label: '+500',
            sub: 'personas'
          }, {
            label: '6',
            sub: 'Tomos'
          }, {
            label: '6',
            sub: 'Bonos'
          }, {
            label: '4.9/5',
            sub: '⭐'
          }].map((stat, i) => <div key={i} className="text-center" data-id="element-155">
                <div className="text-3xl font-bold text-white mb-1" data-id="element-156">
                  {stat.label}
                </div>
                <div className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-157">
                  {stat.sub}
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}